// @flow
import display from './display';
import overlay from './overlay';
import searchParams from './searchParams';
import system from './system';
import abacus from './abacus';
import expandedGroups from './expandedGroups';
import pinnedProperty from './pinnedProperty';
import trip from './trip';
import viewport from './viewport';
import topBanners from './topBanners';
import searchTerm from './searchTerm';
import redirect from './redirect';
import dateRangePicker from './dateRangePicker';
import modals from './modals';
import map from './map';
import header from './header';
import {toasterReducers} from '@homeaway/react-toaster';
import {tripboardButtonReducer} from '@homeaway/react-trip-board-button';

import type {State as AbacusState} from './abacus';
import type {State as DisplayState} from './display';
import type {State as OverlayState} from './overlay';
import type {State as SearchParamsState} from './searchParams';
import type {State as ExpandedGroupsState} from './expandedGroups';
import type {State as PinnedPropertyState} from './pinnedProperty';
import type {State as SystemState} from './system';
import type {State as SearchTermState} from './searchTerm';
import type {State as TripState} from './trip';
import type {State as ViewportState} from './viewport';
import type {State as TopBannersState} from './topBanners';
import type {State as RedirectState} from './redirect';
import type {State as DateRangePickerState} from './dateRangePicker';
import type {State as ModalsState} from './modals';
import type {State as MapState} from './map';
import type {State as HeaderState} from './header';
import type {State as TripBoardButtonState} from './tripBoardButton';

// TODO: Have Router export a state shape since it becomes part of global state
// , OR investigate whether redux-little-router exports state shape.
// see SERP-361
type RouterState = {router: any};

type _State = {
    display: DisplayState,
    overlay: OverlayState,
    searchParams: SearchParamsState,
    system: SystemState,
    abacus: AbacusState,
    expandedGroups: ExpandedGroupsState,
    trip: TripState,
    viewport: ViewportState,
    pinnedProperty: PinnedPropertyState,
    topBanners: TopBannersState,
    redirect: RedirectState,
    dateRangePicker: DateRangePickerState,
    modals: ModalsState,
    map: MapState,
    searchTerm: SearchTermState,
    header: HeaderState,
    tripboardButton: TripBoardButtonState
};

// need to export State with RouterState since Router is not reduced by us
export type State = _State & RouterState;

export type Store = {
    getState: (void) => State,
    dispatch: (any) => any
};

const reducers = {
    display,
    overlay,
    searchParams,
    system,
    searchTerm,
    abacus,
    expandedGroups,
    trip,
    viewport,
    pinnedProperty,
    topBanners,
    redirect,
    dateRangePicker,
    tripboardButton: tripboardButtonReducer,
    toasts: toasterReducers,
    modals,
    map,
    header
};

export default reducers;
